/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';

// identical to sphere-frontend/editor/public/index.html
const CURATOR_HTML_LOADER = `
<div id="html-loader" style="position: fixed; width: 100vw; height: 100vh; z-index: 9999; left: 0; top: 0;">
    <div id="html-loader-background" style="width: 100%; height: 100%; background: linear-gradient(-30deg, rgba(70, 65, 243, 1) 0%, rgba(168, 71, 255, 1) 100%);" />
    <div style="position: absolute; width: 100vw; height: 100vh; left: 50%; top: 50%; transform: translate(-50%, -50%); backdrop-filter: blur(10px);"></div>
    <div style="
      position: absolute; width: 500px; height: 168px; left: 50%; top: 50%; transform: translate(-50%, -50%); padding: 0;
      display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 28px;
      border-radius: 12px; -webkit-backdrop-filter: blur(80px); backdrop-filter: blur(80px);
      background-color: #00000066;"
    >
      <div style="position: relative; overflow: hidden;"><script>
        const DOT_COUNT = 5;
        const DOT_SIZE = 14;
        const GAP = 14;
        const TOTAL_WIDTH = (DOT_SIZE + GAP) * (DOT_COUNT + 1);
        const ANIMATION_PERIOD = 2000;
        const container = document.currentScript.parentElement;
        container.style.width = \`\${TOTAL_WIDTH}px\`;
        container.style.height = \`\${DOT_SIZE}px\`;
        const style = \`position: absolute; width: \${DOT_SIZE}px; height: \${DOT_SIZE}px; border-radius: \${(DOT_SIZE / 2).toFixed(2)}px; background-color: #f44a64;\`;
        const dots = [];
        for (let i = 0; i < DOT_COUNT; i++) {
          const dot = document.createElement('div');
          dot.style = style;
          container.appendChild(dot);
          dots[i] = dot;
        }
        function opacity(t) {
          return Math.min(1, Math.max(0, 10.26 * t * (1 - t) - 0.9231));
        }
        function animate(time) {
          for (let i = 0; i < DOT_COUNT; i++) {
            const dot = dots[i];
            const t = (time / ANIMATION_PERIOD + i / DOT_COUNT) % 1;
            dot.style.left = \`\${(t * TOTAL_WIDTH).toFixed(4)}px\`;
            dot.style.opacity = \`\${opacity(t).toFixed(2)}\`;
          }
          requestAnimationFrame(animate);
        }
        requestAnimationFrame(animate);
      </script></div>
      <div style="font: 16px Arial; color: white;">Please wait a moment for your template to load in Builder</div>
  </div>
</div>`;

export default function HtmlLoader() {
  const wrapper = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapper.current === null) return;
    const script = wrapper.current.querySelector('script')!;
    const clone = document.createElement('script');
    clone.appendChild(document.createTextNode(script.innerHTML));
    script.parentNode!.replaceChild(clone, script);
  }, []);
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: CURATOR_HTML_LOADER }} ref={wrapper} />;
}
